export const TOOLBAR_SEARCH_DEBOUNCE_MS = 150;

export const STATUS_FILTER_OPTIONS: Array<{ value: string; labelKey: string }> =
  [
    { value: 'ANY', labelKey: 'allStatuses' },
    { value: 'ANY_REBALANCE', labelKey: 'needsRebalance' },
    { value: 'DRIFT', labelKey: 'drift' },
    { value: 'TRANSFER', labelKey: 'transfer' },
    { value: 'LIQUIDATE', labelKey: 'liquidation' },
    { value: 'PENDING_TRADES', labelKey: 'trading' },
  ];

export const TYPE_FILTER_OPTIONS: Array<{ value: string; labelKey: string }> = [
  { value: 'ANY', labelKey: 'allTypes' },
  { value: 'GOAL', labelKey: 'goals' },
  { value: 'SUB_ACCOUNT', labelKey: 'subAccounts' },
];

export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const;
